export default __webpack_public_path__ + "static/media/add-photo-icon.915fbd60.svg";